module.exports = __webpack_public_path__ + "img/virado_header_3.934ceee2.jpg";